import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    opportunities: [],
    dialog: false,
    opportunity: {}
  },

  mutations: {
    setOpportunities(state, payload) {
      state.opportunities = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setSelectedOpportunity(state, payload) {
      state.opportunity = payload
    },
    setDialog(state, payload) {
      state.dialog = payload
    }
  },

  actions: {
    read({ commit }) {
      commit('setLoading', true)
      axios.admin
        .get('cms/opportunities')
        .then(r => {
          commit('setOpportunities', r.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    update({ commit, dispatch, state }, id) {
      axios.admin
        .put('cms/opportunities/' + id, {
          title: state.opportunity.title,
          quote: state.opportunity.quote,
          post_link: state.opportunity.post_link,
          position: state.opportunity.position
        })
        .then(() => {
          commit('setDialog', false)
          commit('setSelectedOpportunity', {})
          dispatch('read')
        })
    },
    delete({ dispatch }, id) {
      axios.admin.put('cms/opportunities/delete/' + id).then(() => {
        dispatch('read')
      })
    },
    publish({ dispatch }, id) {
      axios.admin.put('cms/opportunities/publish/' + id).then(() => {
        dispatch('read')
      })
    },
    unpublish({ dispatch }, id) {
      axios.admin.put('cms/opportunities/unpublish/' + id).then(() => {
        dispatch('read')
      })
    },
    insert({ commit, dispatch, state }) {
      axios.admin
        .post('cms/opportunities', {
          title: state.opportunity.title,
          quote: state.opportunity.quote,
          post_link: state.opportunity.post_link,
          position: state.opportunity.position
        })
        .then(() => {
          commit('setDialog', false)
          commit('setOpportunities', {})
          dispatch('read')
        })
    }
  }
}
